import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage showPurchaseToast data-id="element-3" />} data-id="element-2" />
        <Route path="/lp2" element={<SalesPage showPurchaseToast data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}